module.exports = __webpack_public_path__ + "img/blue_073.02a0ebcc.png";